const extensions: Record<string, string> = {
  'video/mp4': 'mp4',
  'video/quicktime': 'mov',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
}

export type MediaAction = 'shared' | 'downloaded' | 'cancelled'

export function mediaFileName(blob: Blob, isVideo: boolean): string {
  return `uig-creation.${extensions[blob.type] ?? (isVideo ? 'mp4' : 'jpg')}`
}

function download(blob: Blob, name: string): MediaAction {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.append(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
  return 'downloaded'
}

async function shareFile(file: File): Promise<MediaAction> {
  try {
    await navigator.share({ files: [file] })
    return 'shared'
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') return 'cancelled'
    throw error
  }
}

function canShareFile(file: File): boolean {
  return typeof navigator.share === 'function' && Boolean(navigator.canShare?.({ files: [file] }))
}

export async function saveMedia(blob: Blob, name: string): Promise<MediaAction> {
  // Saving must never open Share, including on iOS. The browser controls the download destination.
  return download(blob, name)
}

export async function shareMedia(blob: Blob, name: string): Promise<MediaAction> {
  const file = new File([blob], name, { type: blob.type })
  if (canShareFile(file)) return shareFile(file)
  return download(blob, name)
}
